import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router'

import '../styles/confirmation.css';


class ConfirmationUpdateRegister extends Component {
    
   constructor(props) { 
        super(props);
        this.state={}
   }

   render() {

        return (
            <Container >
              <div className="page-register-confirmation">

                    <Row>
                        <Col>
                            <Link to="/prestataire/fiche"><div className="bloc-right center close">X</div></Link>
                        </Col>
                    </Row>

                    <div className="page-register-confirmation-container">
                        <Row>
                            <Col>
                                <div className="confirmation-title">Merci pour votre candiature, nous vous contacterons très vite.</div>
                                <div className="confirmation-subitle nodisplay">
                                    You probably haven't heard of them iceland biodiesel flexitarian. Crucifix letterpress 90's, banh mi humblebrag quinoa iPhone you probably haven't heard of them. Mixtape ennui cornhole tumeric.
                                </div>
                            </Col>
                        </Row>

                    </div>

                    <div  className="page-register-confirmation-container-action">
                      <Row>
                          <Col>
                              <Link to="/prestataire/fiche"><Button className="btn-green">Fermer</Button></Link>
                          </Col>
                      </Row>
                    </div>

                </div>
            </Container>
        )
    }
}


export default ConfirmationUpdateRegister



// WEBPACK FOOTER //
// ./src/btoc/components/ConfirmationUpdateRegister.js